"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Intercom_1 = __importDefault(require("./Intercom"));
exports.default = Intercom_1.default;
//# sourceMappingURL=index.js.map